export function resolveTemplateLayoutMode(pathname: string, mode?: string) {
  const isNewRoute =
    pathname.includes('/templates/estimate/new') || pathname.includes('/templates/proposal/new');
  const isEditMode = mode === 'edit';

  return {
    isFormMode: isNewRoute || isEditMode,
    hideListInSplit: isNewRoute,
  };
}
